<template>
  <div :class="['content-wrap']">
    <glass>
      <h1
        v-dompurify-html="banners.title"
        class="form-title"
      />

      <template v-if="rip">
        <rip-block :texts="ripTexts" />
      </template>
      <template v-else>
        <div
          v-if="banners.description"
          v-dompurify-html="banners.description"
          class="description"
        />

        <my-booking-form />
      </template>
    </glass>
  </div>
</template>


<script>
  import Glass from 'components/Glass'
  import { mapState } from 'vuex'

  export default {
    name: "MMB",
    components: {
      Glass,
      RipBlock: () => import(/* webpackChunkName: "rip-block" */ 'components/Forms/Index/RipBlock'),
      MyBookingForm: () => import(/* webpackChunkName: "my-booking-form "*/ 'components/Forms/Index/Form/MyBookingForm')
    },
    props: {
      rip: {
        type: Boolean,
        required: false,
        default: false
      },
      ripTexts: {
        type: Object,
        required: false,
        default: () => {}
      },
      mobileDirectionType: {
        type: Boolean,
        default: null,
        required: false
      },
      isMainForm: {
        type: Boolean,
        default: false
      },
      banners: {
        type: Object,
        required: true,
        default: () => ({
          title: '',
          description: ''
        })
      }
    },
    computed: {
      ...mapState('mmbForm', [
        'refundError',
        'errorRef'
      ]),
    },
    mounted () {
      document.body.setAttribute('tabindex', -1)

      this.showRefundError()
    },
    methods: {
      openModal (props) {

        const RefundError = import(/* webpackChunkName: "refund-error" */ 'components/Notifications/RefundError')

        RefundError.then((result) => {
          this.$store.commit('main/setModalContent', result.default)
        })

        this.$store.dispatch('main/openModal')
        this.$store.commit('main/setShowModalHeader', false)
        this.$store.commit('main/setShowModalHeaderWhite', false)
        this.$store.commit('main/setModalType', 'centered')
        this.$store.commit('main/setModalClass', 'modal-white-centered wide')
        this.$store.commit('main/setShowCloseIcon', true)
        this.$store.commit('main/setModalCloseFn', this.closeModal)
        this.$store.commit('main/setModalProps', props)
      },
      closeModal () {
        this.$store.dispatch('main/closeModal')
        this.$store.commit('mmbForm/setRefundError', false)
      },
      showRefundError () {
        const props = {
          errorMessage: this.$t('mmbForm.refundError.messageRefund'),
          errorTitle: this.$t('mmbForm.refundError.modalTitleRefund'),
          errorSubtitle: `${this.$t('checkInForm.errorRef')}:  ${this.errorRef}`
        }

        if (this.refundError) {
          this.openModal(props)
        }
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .content-wrap {
    padding: 16px 12px 32px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: white;

    @include bp-mf-tablet {
      padding: 16px 24px 32px;
      height: auto;
    }

    @include bp-mf-desktop {
      margin: 0 auto;
      flex-direction: row;
      justify-content: space-between;
      max-width: $desktop-wide-width;
      background: transparent;
      width: 100%;
    }

    @include bp-mf-desktop-large {
      padding: 16px 0 32px;
    }
  }

  .form-title {
    @include defaultFontValues($blue-dark, 24, 28, 500);
    margin: 0 0 16px;

    @include bp-mf-desktop {
      font-size: em(32);
      margin: 0 0 29px;
    }
  }

  .description {
    @include defaultFontValues($blue-dark, 12, 18);
    margin: 0 0 16px;

    @include bp-mf-desktop {
      font-size: em(14);
      line-height: 20px;
      margin: 0 0 27px;
      width: 80%;
    }
  }
</style>

